export const MAX_PAGE_CONTAINER_WIDTH = 'lg';

export const SLUGS_TO_PRE_LOAD_IMAGE = ['teams-homepage', 'c4b-homepage'];
